import { useMemo } from 'react';

import { Text } from '@chakra-ui/react';
import { t } from '@lingui/macro';

import useIsMobile from '../../../../hooks/useIsMobile';
import InputCheckbox from '../../../generic/form/InputCheckbox';
import InputText, { getDynamicInputMaxWidth } from '../../../generic/form/InputText';
import InputTextArea from '../../../generic/form/InputTextArea';
import Select from '../../../generic/form/Select';

const SpecificDataCustom = ({ data, fieldValue, onParticipantDataUpdate, requiredFromProps = null, useDynWidth = true }) => {
  const isMobile = useIsMobile();

  // label is internal, name is public
  const { id, data_type: dataType, label, name, required: requiredFromData, choices } = data;
  const fieldChoices = useMemo(() => getFieldChoices(choices), [data]);

  const fieldProps = {
    fieldName: id,
    isRequired: requiredFromProps === 1 || requiredFromData === 1,
    fieldLabel: name,
    fieldPlaceholder: name,
    fieldValue: fieldValue,
    onChange: (fName, fieldValue, selectLabel) => onParticipantDataUpdate(id, label, fieldValue, selectLabel),
  };

  if (useDynWidth) {
    fieldProps['maxWidth'] = { base: '', md: getDynamicInputMaxWidth(data.name, isMobile) };
  }

  return (
    <>
      {(dataType === 'number' || dataType === 'text') && <InputText fieldType={dataType} {...fieldProps} />}
      {dataType === 'textarea' && <InputTextArea {...fieldProps} maxWidth={undefined} />}
      {dataType === 'select' && <Select fieldChoices={fieldChoices} {...fieldProps} />}
      {dataType === 'checkbox' && (
        <InputCheckbox showRequiredStar {...fieldProps}>
          <Text fontSize=".8rem" fontWeight="medium" color="brand.color_main">
            {name}
          </Text>
        </InputCheckbox>
      )}
    </>
  );
};

export default SpecificDataCustom;

const getFieldChoices = choices => {
  const fieldChoices = [{ label: t`None`, value: '' }];
  for (const choice of choices) {
    fieldChoices.push({ label: choice.name, value: choice.id });
  }
  return fieldChoices;
};
